export var buildNodeLevelPropName = function buildNodeLevelPropName(level) {
  return "level".concat(level, "Node");
};